export default "__VITE_ASSET__959fa388__"